export const ACCRUALS_DATA_TABS = [
  { id: 'open_po', label: 'Purchase Order', entityType: 'open_po' },
  { id: 'accruals_ledger', label: 'Accruals ledger', entityType: 'accruals_ledger' },
  { id: 'ap_postings', label: 'Accounts Payable', entityType: 'ap_postings' },
  { id: 'vendor_master', label: 'Vendor Master', entityType: 'vendor_master' },
  { id: 'open_invoices', label: 'Unapproved Invoices', entityType: 'open_invoices' },
];

export const ACCRUALS_SYNC_ENTITY_OPTIONS = [
  { value: 'open_po', label: 'Purchase Order (PO)' },
  { value: 'ap_postings', label: 'Accounts Payable (AP)' },
  { value: 'vendor_master', label: 'Vendor Master (VM)' },
  { value: 'accruals_ledger', label: 'Accruals Ledger (AL)' },
  { value: 'open_invoices', label: 'Unapproved Invoices (OI)' },
];

/** Maps landing-page metric keys → data workspace tab ids */
export const ACCRUALS_METRIC_TO_DATA_TAB = {
  open_po: 'open_po',
  ap_postings: 'ap_postings',
  accruals_ledger: 'accruals_ledger',
  vendor_master: 'vendor_master',
};

export function getAccrualsTabById(tabId) {
  return ACCRUALS_DATA_TABS.find((tab) => tab.id === tabId) || ACCRUALS_DATA_TABS[0];
}

export function getDataTabIdFromMetricKey(metricKey) {
  return ACCRUALS_METRIC_TO_DATA_TAB[metricKey] || ACCRUALS_DATA_TABS[0].id;
}

export function isValidDataTabId(tabId) {
  return ACCRUALS_DATA_TABS.some((tab) => tab.id === tabId);
}

/** Synthetic mapping source: fill blank po_line_number as _L1…n per po_number. */
export const GENERATE_PO_LINE_SEQUENCE_SOURCE = '__generate_po_line_sequence__';
export const GENERATE_PO_LINE_SEQUENCE_LABEL = 'Generate line sequence (_L1…n)';

export function getSyncEntityLabel(entityType) {
  const match = ACCRUALS_SYNC_ENTITY_OPTIONS.find((option) => option.value === entityType);
  return match?.label || entityType;
}

export function formatAccrualsColumnLabel(column) {
  return String(column || '')
    .replace(/_/g, ' ')
    .toUpperCase();
}

export function filterOptionsToRows(filterOptions = {}) {
  const rows = [];
  Object.entries(filterOptions).forEach(([column, values]) => {
    (values || []).forEach((value) => {
      rows.push({ [column]: value });
    });
  });
  return rows;
}
